angular.module('cfn').component('greeningCatchCrop', {
  bindings: {
    chartDataCatchCrop: '<',
    chartDataInsideCrop: '<',
    isSecondFruit: '<',
    plannedFruits: '<'
  },
  controller: GreeningCatchCropController,
  controllerAs: 'vm',
  templateUrl: require('./greeningCatchCrop.html')
});

function GreeningCatchCropController() {}
